let modulePromise;
document.addEventListener('click', async (event) => {
  const trigger = event.target.closest?.('[data-search-open]');
  // Triggers outside the header (e.g. the mobile toolbar) open the header's search dialog.
  const root = trigger && (trigger.closest('[data-header-root]') || document.querySelector('[data-header-root]'));
  if (!root?.querySelector('[data-search-dialog]')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  try {
    const module = await (modulePromise ||= import('./predictive-search.js'));
    module.mountPredictiveSearch(root)?.open({ preventDefault() {}, currentTarget: trigger });
  } catch {
    window.location.assign(trigger.href);
  }
}, true);
